module.exports = __webpack_public_path__ + "static/img/supadog3.bdce8843.png";